import styled from "styled-components";
import { Link } from "gatsby";

export default styled(Link)``;
